<template>
  <div class="app-container">
    <div class="module-wrap">
      <el-descriptions title="基础信息" >
        <el-descriptions-item label="组织编号">{{
          formData.partnershipId || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="承运商名称">{{
          formData.partnerName || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="承运中旧机数量">{{
          formData.carryOldMachineNum === 0 || formData.carryOldMachineNum > 0
            ? formData.carryOldMachineNum
            : "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="保证金总额">{{
          formData.bondAmount
        }}</el-descriptions-item>
        <el-descriptions-item label="已占用保证金">{{
          formData.usedBondAmount
        }}</el-descriptions-item>

        <el-descriptions-item label="未占用保证金">{{
          formData.unuseBondAmount
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-title">保证金记录</div>
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="回收单号" prop="orderNo">
        <el-input
          v-model="search.orderNo"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="类型" prop="type">
        <el-select
          v-model="search.type"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="(val, key) in typeOption"
            :key="key"
            :label="val"
            :value="key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作人" prop="createdName">
        <el-input
          v-model="search.createdName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="时间" prop="createdTime">
        <el-date-picker
          v-model="createdTime"
          clearable
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="openModal('payment')"
        >保证金缴纳</el-button
      >
      <el-button type="primary" size="medium" @click="openModal('deduct')"
        >保证金扣除</el-button
      >
      <el-button type="primary" size="medium" @click="exportExcel()"
        >导出</el-button
      >
      <el-button type="primary" size="medium" @click="getList()"
        >查询</el-button
      >
      <el-button size="medium" @click="resetForm">重置</el-button>
    </div>
    <el-table
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
      width="100%"
    >
      <el-table-column
        label="回收单号"
        prop="orderNo"
        width="160"
      ></el-table-column>

      <el-table-column label="金额" prop="amount"></el-table-column>
      <el-table-column label="类型" prop="type">
        <template slot-scope="scope">{{ typeOption[scope.row.type] }}</template>
      </el-table-column>
      <el-table-column label="操作人" prop="createdName"></el-table-column>
      <el-table-column label="凭证" prop="fileId">
        <template slot-scope="scope">
          <image-upload
            v-if="scope.row.fileId"
            :imageUrl.sync="scope.row.fileId"
            :editMode="false"
            :appendToBody="true"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="时间" prop="createdDate"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.currPage"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <earnestMoneyModal
      ref="earnestMoneyModalRef"
      @opera-success="getDetailInfo"
    ></earnestMoneyModal>
  </div>
</template>
<script>
import { findBondSerialByPartnershipId, getPartnerList } from "@/api/oldForNew";
import { orderStatusOption } from "./mixin.js";
import earnestMoneyModal from "./components/earnestMoneyModal";
import imageUpload from "@/components/Upload/ImageUpload";

export default {
  name: "carrierDetail",
  components: { earnestMoneyModal, imageUpload },
  filters: {},
  props: {
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      list: [],
      optionList: {},
      total: null, //列表总条数
      listLoading: false,
      createdTime: [], //开始时间
      formData: {}, // this.$route.params.rowData, //基础信息
      id: this.$route.query.id,
      search: {
        partnershipId: this.$route.query.id, //承运商 id
        orderNo: null,
        type: null,
        createdName: null,
        createdStartDate: null,
        createdEndDate: null,
        currPage: 1, //当前页
        pageSize: 10
      },
      typeOption: { 1: "缴纳", 2: "占用", 3: "释放", 4: "扣除" }, //是否有待回收旧机
      partnershipType: null //当前用户所属组织 1 子公司 2 第三方 3 总公司
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.getDetailInfo();
    } else {
      this.$router.push({
        path: "/oldForNewService/carrier"
      });
    }
  },
  methods: {
    async getList() {
      if (this.createdTime && this.createdTime.length) {
        this.search.createdStartDate = this.createdTime[0] + " 00:00:00";
        this.search.createdEndDate = this.createdTime[1] + " 23:59:59";
      } else {
        this.search.createStartDate = this.search.createEndDate = null;
      }
      let {
        statusCode,
        data,
        total,
        message
      } = await findBondSerialByPartnershipId(this.search);
      if (statusCode == 200) {
        this.list = data || [];
        this.total = total || 0;
      } else {
        this.$message.error(message);
      }
    },
    //或取承诺商的保证金详情
    async getDetailInfo() {
      const params = {
        partnerName: null,
        orgNo: this.search.partnershipId,
        currPage: 1, //当前页
        pageSize: 10
      };
      let { statusCode, data, message } = await getPartnerList(params);
      if (statusCode == 200 && data) {
        this.formData = data[0];
      } else {
        this.$message.error(message);
      }
      this.getList();
    },

    resetForm() {
      Object.assign(this.search, {
        orderNo: null,
        type: null,
        createdName: null,
        createdStartDate: null,
        createdEndDate: null,
        currPage: 1,
        pageSize: 10
      });
      this.createdTime = [];
    },
    handleSizeChange(val) {
      this.search.currPage = 1;
      this.search.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    //保证金缴纳/扣除 flag
    openModal(flag) {
      this.$refs.earnestMoneyModalRef.openDialog(this.formData, flag);
    },
    //导出承运商保证金管理
    exportExcel() {
      let url =
        "/autoapp-default-server-recovery/api/partnerManagementBond/exportBondSerial";
      let title = "导出承运商保证金管理列表";
      this.global.exportExcel(url, this.search, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: "application/json"
        });
        var blobReader = new Response(blob).json();
        blobReader.then(res => {
          this.$message.error(res.message);
        });
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}

.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.module-wrap {
  margin-bottom: 20px;
}
.module-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/carrierDetail.vue